import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDsChucDanhChuyenMon } from '../../services/danhmuc';

const ChucDanhChuyenMonSelectBox = ({ value, optionAll, disabled, onChange, allowClear }: { value?: number, optionAll?: boolean, disabled?: boolean, onChange: (e: any) => void, allowClear?: boolean }) => {
    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDsChucDanhChuyenMon();
            if (optionAll && rs.length > 1) {
                rs = [{ value: 0, label: "--Tất cả--" }, ...rs];
            };
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        <Select
            style={{ width: '100%', height: '35px' }}
            showSearch
            placeholder="--Chọn chức danh chuyên môn--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            value={value}
            options={data}
            disabled={disabled}
            onChange={(e) => {
                onChange({
                    target: {
                        value: e
                    }
                })
            }}
            allowClear={allowClear}
        />
    );
};

export default ChucDanhChuyenMonSelectBox;
